import { defineQuery } from "next-sanity";

export const drlpLiveSlugsQuery = defineQuery(`
*[_type == "drlpPage" && isLive == true && site == $site] { "slug": slug.current }
`);
